import { useState, useReducer, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { HiOutlineChevronRight } from "react-icons/hi"

import Union from "../components/svg/Union"
import Academy from "../components/svg/Academy"
import Tuition from "../components/svg/Tuition"
import Seminars from "../components/svg/Seminars"
import Curriculum from "../components/svg/Curriculum"
import Course from "../components/svg/Course"
import TutionReport from "../components/svg/TutionReport"
import Calendar from "../components/svg/Calendar"

import SidebarItem from "../components/SidebarItem"
import Dashboard from "../components/svg/Dashboard"
import Logout from "../components/svg/Logout"
import Logo from "../components/svg/Logo"
import Alerts from "../components/svg/Alerts"
import School from "../components/svg/School"

import OperationsSVG from "../components/svg/OperationsSVG"
import SalesSVG from "../components/svg/SalesSVG"
import TutorSubmission from "../components/svg/TutorSubmission"
import TutorDashboard from "../components/svg/TutorDashboard"
import Whatsapp from "../components/svg/Whatsapp"
import { api } from "../util/APIConfig"
import jwtDecode from "jwt-decode"
import { differenceInWeeks } from "date-fns"
import { getStudentMetadata } from "../API/API"
import Targets from "../components/svg/Targets"
import TutorHelp from "../components/svg/TutorHelp"
import { headStartQuestionBank } from "../util/dataHelpers"

function LayoutAside({ navActive, setActiveNav, schoolName, schoolImage }) {
  const [role, setRole] = useState()
  const [isSeminarTutor, setIsSeminarTutor] = useState(false)
  const [isEssayPSTutor, setIsEssayPSTutor] = useState(false)
  const [isHeadStartStudent, setIsHeadStartStudent] = useState(false)
  const [impersonating, setImpersonating] = useState(false)
  const [userHasSchoolImage, setUserHasSchoolImage] = useState(false)
  const [hasQuestionBank, setHasQuestionBank] = useState(false)
  const [showUpgrades, setShowUpgrades] = useState(false)

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const token = localStorage.getItem("token")
    const decodedData = jwtDecode(token)

    setRole(decodedData.role)
    //setEmail(decodedData.email)
    const userRole = decodedData.role;

    let studentSchool = null;

    if(userRole == "Student")
    {
      /*getStudentMetadata().then(res => {
        const creationDate = new Date(res.data.data.createdDate);
        const weeksSinceCreation = differenceInWeeks(new Date(), creationDate);
        setShowUpgrades(weeksSinceCreation >= 3);
      });*/

      if (decodedData.Schools) {
        const { Schools: schools } = decodedData;
      
        if (typeof schools === 'string') {
          studentSchool = schools
        } else if (Array.isArray(schools) && schools.length > 0) {
          studentSchool = schools[0]
        }
      }
    }

    if((userRole == "Student" && studentSchool) || userRole == "School Manager")
    {
      setUserHasSchoolImage(true)
    }

    if(userRole == "Student" && decodedData.IsHeadStart)
    {
      setIsHeadStartStudent(decodedData.IsHeadStart == "True")
    }

    if(userRole == "Student")
    {
      const hasQuestionBank = decodedData?.HasQuestionBank === "True"
      setHasQuestionBank(hasQuestionBank || headStartQuestionBank.includes(decodedData.email))
    }

    if(userRole === "Tutor")
    {
      const itemST = decodedData?.isseminartutor;
      const itemEPT = decodedData?.isessaypstutor;
      
      let hasST = false;
      let hasEPT = false;
      if(itemST != null && itemST == "True") hasST = true;
      if(itemEPT != null && itemEPT == "True") hasEPT = true;

      setIsSeminarTutor(hasST);
      setIsEssayPSTutor(hasEPT);
    }
    
    const impersonator = decodedData?.IsImpersonating
    if(impersonator == "true")
    {
      setImpersonating(true)
    }

  }, [])

  const [open, setOpen] = useState(true)

  useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth < 1024 && setOpen(true)
    )
    return () => window.removeEventListener("resize", () => {})
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const [childrenVisibility, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case "TOGGLE":
          return {
            [action.id]: true
          }
        case "RESET":
          return {}

        case "UPDATE":
          return {
            ...state,
            [action.id]: !state[action.id]
          }

        default:
          return state
      }
    },
    {
      operations: true
    }
  )

  const onListItemClick = ({ path, type, id }) => {
    // if (path !== "academy") useStore.setState({ page: 1 })
    navigate(path)
    if (type === "TOGGLE") {
      dispatch({ type: "TOGGLE", id })
    } else {
      dispatch({ type: "RESET" })
    }
  }

  const onListItemChildrenClick = (event, path) => {
    event.stopPropagation()
    navigate(path)
  }

  const stopImpersonation = async () => {
    try {
      const data = await api.post('/authentication/admin/impersonation/stopImpersonation', { });
      if (data) {
        //console.log(data.data); // Update the context and localStorage with the new token
        const decodedData = jwtDecode(data.data.data.accessToken)
        //console.log(decodedData)
        localStorage.setItem("token", data.data.data.accessToken)
        localStorage.setItem("refreshToken", data.data.data.refreshToken)
        localStorage.setItem("email", decodedData.email)

        if(decodedData.role == 'Admin') window.location = '/audit-dashboard'
        else if(decodedData.role == 'Parent' || decodedData.role == 'School Manager' || decodedData.role == 'Tutor' || decodedData.role == 'Senior Tutor') window.location = '/'
        else window.location = '/audit-dashboard'
      }
    } catch (error) {
      console.error('Error starting impersonation:', error);
    }
  };

  const BASE_PATH = "/" + location.pathname.split("/")[1]

  const svgFill = path => (path === BASE_PATH ? "#FFF" : "#A5A5A5")

  const curriculumPath = "/curriculum"
  const curriculumFill = svgFill(curriculumPath)
  const CurriculumSVG = () => (
    <Curriculum fill={curriculumFill} width="22px" height="22px" />
  )

  const tutorSubmissionsPath = "/submissions"
  const tutorSubmissionsFill = svgFill(tutorSubmissionsPath)
  const TutorSubmissionsSVG = () => (
    <TutorSubmission fill={tutorSubmissionsFill} width="22px" height="22px" />
  )

  const tutorMyStudentsPath = "/"
  const tutorMyStudentsFill = svgFill(tutorMyStudentsPath)
  const TutorMyStudentsSVG = () => (
    <TutorDashboard fill={tutorMyStudentsFill} width="22px" height="22px" />
  )

  const dashboardPath = "/"
  const dashboardFill = svgFill(dashboardPath)
  const DashboardSVG = () => (
    <Dashboard fill={dashboardFill} width="22px" height="22px" />
  )

  const tuitionPath = "/tuition"
  const lessonReportsPath = "/tuition/tuition-reports"
  const tuitionFill = svgFill(tuitionPath)
  const TuitionSVG = () => (
    <Tuition fill={tuitionFill} width="22px" height="22px" />
  )
  const tuitionChildrenList = [
    {
      title: "Tuition Reports",
      path: lessonReportsPath,
      onClick: event => {
        onListItemChildrenClick(event, lessonReportsPath)
        setActiveNav(false)
      }
    },
    {
      title: "Report Card",
      path: "/report-card",
      onClick: event => {
        onListItemChildrenClick(event, "/report-card")
        setActiveNav(false)
      }
    }
  ]

  const targetsPath = "/tutor-targets"
  const targetsFill = svgFill(targetsPath)
  const TargetsSVG = () => (
    <Targets fill={targetsFill} width="22px" height="22px" />
  )

  const lessonPlansAndGuidesPath = "/resources/lesson-plans-and-guides"
  const downloadPastPapersPath = "/resources/download-past-papers"

  const resourcesPath = "/resources"
  const readingPath = "/resources/reading"
  const libraryPath = "/resources/library"
  const submissionsPath = "/resources/submissions"
  const questionBankPath = "/resources/question-bank"
  const studentFlaggedQuestionsPath = "/resources/student-flagged-questions"
  const resourcesFill = svgFill(resourcesPath)
  const ResourcesSVG = () => (
    <Union fill={resourcesFill} width="22px" height="22px" />
  )
  const resourcesChildrenList = [
    {
      title: "Question Bank",
      path: questionBankPath,
      hidden: !hasQuestionBank,
      onClick: event => {
        onListItemChildrenClick(event, questionBankPath)
        setActiveNav(false)
      }
    },
    {
      title: "Flagged Questions",
      path: studentFlaggedQuestionsPath,
      hidden: (role === "Tutor" || role === "Senior Tutor") || (!hasQuestionBank),
      onClick: event => {
        onListItemChildrenClick(event, studentFlaggedQuestionsPath)
        setActiveNav(false)
      }
    },
    {
      title: "Submissions",
      path: submissionsPath,
      hidden: role === "Tutor" || role === "Senior Tutor",
      onClick: event => {
        onListItemChildrenClick(event, submissionsPath)
        setActiveNav(false)
      }
    },
    {
      title: "Library",
      path: libraryPath,
      onClick: event => {
        onListItemChildrenClick(event, libraryPath)
        setActiveNav(false)
      }
    },
    {
      title: "Reading",
      path: readingPath,
      hidden: role === "Tutor" || role === "Senior Tutor",
      onClick: event => {
        onListItemChildrenClick(event, readingPath)
        setActiveNav(false)
      }
    },
    {
      title: "Lesson plans and guides",
      path: lessonPlansAndGuidesPath,
      hidden: role !== "Tutor",
      onClick: event => {
        onListItemChildrenClick(event, lessonPlansAndGuidesPath)
        setActiveNav(false)
      }
    },
    {
      title: "Download Past Papers",
      path: downloadPastPapersPath,
      hidden: role !== "Tutor",
      onClick: event => {
        onListItemChildrenClick(event, downloadPastPapersPath)
        setActiveNav(false)
      }
    }
  ]

  const coursePath = "/courses"
  const courseFill = svgFill(coursePath)
  const CourseSVG = () => (
    <Course fill={courseFill} width="22px" height="22px" />
  )
  const academyPath = "/academy"
  const academyFill = svgFill(academyPath)
  const AcademySVG = () => (
    <Academy fill={academyFill} width="22px" height="22px" />
  )

  const seminarsPath = "/seminars"
  const seminarsFill = svgFill(seminarsPath)
  const SeminarsSVG = () => (
    <Seminars fill={seminarsFill} width="22px" height="22px" />
  )

  // Admin routes

  const salesPath = "/sales"
  const salesFill = svgFill(salesPath)

  const SalesIcon = () => (
    <SalesSVG fill={salesFill} width="22px" height="22px" />
  )

  const operationsPath = "/"
  // const tutorsPath = "/operations/tutors"
  const submissionsPathAdmin = "/submissions"
  const academyPathAdmin = "/academy"
  const curriculumPathAdmin = "/curriculum"
  const blogsPath = "/blogs"
  const readingListPathAdmin = "/reading-list"
  const questionBankPathAdmin = "/question-bank"
  const multiYearCurriculumPathAdmin = "/multi-year-curriculum-admin"
  const seminarsPathAdmin = "/seminars"
  const coursesPathAdmin = "/courses"
  const upgradesPath = "/upgrades"
  const notificationsPath = "/notifications"
  const alertsPath = "/alerts"
  const accountsPath = "/accounts"
  const announcementsPath = "/announcements"
  const auditDashboardPath = "/audit-dashboard"
  const rcTrackingDashboardPath = "/report-card-tracking-dashboard"
  const labelManagementPath= "/label-management"
  const manageLibraryPath = "/manage-library"
  const manageTutorDownloadsPath = "/manage-lesson-plans-and-guides"
  const manageTutorFAQsPath = "/manage-tutor-faqs"

  const tuitionFillAdmin = svgFill(operationsPath)

  // Parent routes
  const parentDashboardPath = "/"
  const dashboardFillPrent = svgFill(parentDashboardPath)
  const ParentDashboardSVG = () => (
    <Dashboard fill={dashboardFillPrent} width="22px" height="22px" />
  )

  const parentCalendarPath = "/calendar"
  const calendarFill = svgFill(parentCalendarPath)
  const CalendarSVG = () => (
    <Calendar fill={calendarFill} width="22px" height="22px" />
  )

  const parentCurriculumPath = "/curriculum"
  const curriculumFillPaarent = svgFill(parentCurriculumPath)
  const ParentCurriculumSVG = () => (
    <Curriculum fill={curriculumFillPaarent} width="22px" height="22px" />
  )
  const parentTutionReportPath = "/tuition-reports"
  const tutionReportFillPaarent = svgFill(parentTutionReportPath)
  const ParentTutionReportSVG = () => (
    <TutionReport fill={tutionReportFillPaarent} width="22px" height="22px" />
  )
  const parentAlertsPath = "/alerts"
  const alertsFillPaarent = svgFill(parentAlertsPath)
  const ParentsAlertsSVG = () => (
    <Alerts fill={alertsFillPaarent} width="22px" height="22px" />
  )

  // School Routes
  const schoolDashboardPath = "/"
  const dashboardFillSchool = svgFill(schoolDashboardPath)
  const SchoolDashboardSVG = () => (
    <School fill={dashboardFillSchool} width="22px" height="22px" />
  )

  const schoolTutionReportsPath = "/tuition-reports"
  const tutionReportFillSchool = svgFill(schoolTutionReportsPath)
  const SchoolTutionReportSVG = () => (
    <TutionReport fill={tutionReportFillSchool} width="22px" height="22px" />
  )

  // const schoolAlertsPath = "/alerts"
  // const alertsFillSchool = svgFill(schoolAlertsPath)
  // const SchoolAlertsSVG = () => (
  //   <Alerts fill={alertsFillSchool} width="22px" height="22px" />
  // )
  const schoolHelpPath = "/help"
  const helpFillSchool = svgFill(schoolHelpPath)
  const SchoolHelpSVG = () => (
    <Whatsapp fill={helpFillSchool} width="22px" height="22px" />
  )

  const OperationsIcon = () => (
    <OperationsSVG fill={tuitionFillAdmin} width="22px" height="22px" />
  )

  const operationsChildrenList = [
    {
      title: "Audit Dashboard",
      path: auditDashboardPath,
      onClick: event => {
        onListItemChildrenClick(event, auditDashboardPath)
        setActiveNav(false)
      }
    },
    {
      title: "Labels",
      path: labelManagementPath,
      onClick: event => {
        onListItemChildrenClick(event, labelManagementPath)
        setActiveNav(false)
      }
    },
    {
      title: "RC Tracking Dashboard",
      path: rcTrackingDashboardPath,
      onClick: event => {
        onListItemChildrenClick(event, rcTrackingDashboardPath)
        setActiveNav(false)
      }
    },
    {
      title: "Submissions",
      path: submissionsPathAdmin,
      onClick: event => {
        onListItemChildrenClick(event, submissionsPathAdmin)
        setActiveNav(false)
      }
    },
    {
      title: "Academy",
      path: academyPathAdmin,
      onClick: event => {
        onListItemChildrenClick(event, academyPathAdmin)
        setActiveNav(false)
      }
    },
    {
      title: "Curriculum",
      path: curriculumPathAdmin,
      onClick: event => {
        onListItemChildrenClick(event, curriculumPathAdmin)
        setActiveNav(false)
      }
    },
    {
      title: "Multi-Year Curriculum Admin",
      path: multiYearCurriculumPathAdmin,
      onClick: event => {
        onListItemChildrenClick(event, multiYearCurriculumPathAdmin)
        setActiveNav(false)
      }
    },
    {
      title: "Seminars",
      path: seminarsPathAdmin,
      onClick: event => {
        onListItemChildrenClick(event, seminarsPathAdmin)
        setActiveNav(false)
      }
    },
    {
      title: "Courses",
      path: coursesPathAdmin,
      onClick: event => {
        onListItemChildrenClick(event, coursesPathAdmin)
        setActiveNav(false)
      }
    },
    {
      title: "Upgrades",
      path: upgradesPath,
      onClick: event => {
        onListItemChildrenClick(event, upgradesPath)
        setActiveNav(false)
      }
    },
    // Blogs
    {
      title: "Blogs",
      path: blogsPath,
      onClick: event => {
        onListItemChildrenClick(event, blogsPath)
        setActiveNav(false)
      }
    },
    {
      title: "Reading List",
      path: readingListPathAdmin,
      onClick: event => {
        onListItemChildrenClick(event, readingListPathAdmin)
        setActiveNav(false)
      }
    },
    {
      title: "Question Bank",
      path: questionBankPathAdmin,
      onClick: event => {
        onListItemChildrenClick(event, questionBankPathAdmin)
        setActiveNav(false)
      }
    },
    {
      title: "Alerts",
      path: alertsPath,
      onClick: event => {
        onListItemChildrenClick(event, alertsPath)
        setActiveNav(false)
      }
    },
    {
      title: "Accounts",
      path: accountsPath,
      onClick: event => {
        onListItemChildrenClick(event, accountsPath)
        setActiveNav(false)
      }
    },
    {
      title: "Announcements",
      path: announcementsPath,
      onClick: event => {
        onListItemChildrenClick(event, announcementsPath)
        setActiveNav(false)
      }
    },
    {
      title: "Notifications",
      path: notificationsPath,
      onClick: event => {
        onListItemChildrenClick(event, notificationsPath)
        setActiveNav(false)
      }
    },
    {
      title: "Manage Library",
      path: manageLibraryPath,
      onClick: event => {
        onListItemChildrenClick(event, manageLibraryPath)
        setActiveNav(false)
      }
    },
    {
      title: "Plan & Guides",
      path: manageTutorDownloadsPath,
      onClick: event => {
        onListItemChildrenClick(event, manageTutorDownloadsPath)
        setActiveNav(false)
      }
    },
    {
      title: "Tutor FAQs",
      path: manageTutorFAQsPath,
      onClick: event => {
        onListItemChildrenClick(event, manageTutorFAQsPath)
        setActiveNav(false)
      }
    }
  ]

  const listProps = [
    {
      title: "Curriculum",
      path: curriculumPath,
      svg: <CurriculumSVG />,
      hidden: role !== "Student",
      onListItemClick: () => {
        onListItemClick({ path: curriculumPath })
        setActiveNav(false)
      }
    },
    {
      title: "Dashboard",
      path: dashboardPath,
      svg: <DashboardSVG />,
      hidden: role !== "Student",
      onListItemClick: () => {
        onListItemClick({ path: dashboardPath })
        setActiveNav(false)
      }
    },
    {
      title: "Tuition",
      path: tuitionPath,
      svg: <TuitionSVG />,
      hidden: role !== "Student",
      onListItemClick: () => {
        onListItemClick({ path: tuitionPath, type: "TOGGLE", id: "tuition" })
        setActiveNav(false)
      },
      hasChildrenVisible: childrenVisibility.tuition,
      childrenList: tuitionChildrenList,
      expandChildren: () =>
        dispatch({
          type: "UPDATE",
          id: "tuition"
        })
    },
    {
      title: "Tutor Targets",
      path: targetsPath,
      svg: <CurriculumSVG />,
      hidden: role !== "Tutor",
      onListItemClick: () => {
        onListItemClick({ path: targetsPath })
        setActiveNav(false)
      }
    },
    {
      title: "Resources",
      path: resourcesPath,
      svg: <ResourcesSVG />,
      hidden: role !== "Student" && role !== "Tutor" && role !== "Senior Tutor",
      onListItemClick: () => {
        onListItemClick({
          path: resourcesPath,
          type: "TOGGLE",
          id: "resources"
        })
        setActiveNav(false)
      },
      hasChildrenVisible: childrenVisibility.resources,
      childrenList: resourcesChildrenList,
      expandChildren: () =>
        dispatch({
          type: "UPDATE",
          id: "resources"
        })
    },
    {
      title: "Courses",
      path: coursePath,
      svg: <CourseSVG />,
      hidden: role !== "Student" || (role == "Student" && isHeadStartStudent),
      onListItemClick: () => {
        onListItemClick({ path: coursePath })
        setActiveNav(false)
      }
    },
    {
      title: "Academy",
      path: academyPath,
      svg: <AcademySVG />,
      hidden: role !== "Student" && role !== "Tutor" && role !== "Senior Tutor",
      onListItemClick: () => {
        onListItemClick({ path: academyPath })
        setActiveNav(false)
      }
    },

    {
      title: "Sales",
      path: salesPath,
      svg: <SalesIcon />,
      hidden: role !== "Admin",
      onListItemClick: () => {
        onListItemClick({
          path: salesPath,
          type: "TOGGLE",
          id: "sales"
        })
        setActiveNav(false)
      }
    },
    {
      title: "Operations",
      path: operationsPath,
      svg: <OperationsIcon />,
      hidden: role !== "Admin",
      onListItemClick: () => {
        onListItemClick({
          path: operationsPath,
          type: "TOGGLE",
          id: "operations"
        })
        setActiveNav(false)
      },
      hasChildrenVisible: childrenVisibility.operations,
      childrenList: operationsChildrenList,
      expandChildren: () =>
        dispatch({
          type: "UPDATE",
          id: "operations"
        })
    },
    {
      title: "My Students",
      path: tutorMyStudentsPath,
      svg: <TutorMyStudentsSVG />,
      hidden: role !== "Tutor" && role !== "Senior Tutor",
      onListItemClick: () => {
        onListItemClick({ path: tutorMyStudentsPath })
        setActiveNav(false)
      }
    },

    {
      title: "Submissions",
      path: tutorSubmissionsPath,
      svg: <TutorSubmissionsSVG />,
      hidden: (role !== "Tutor" && role !== "Senior Tutor") || (role === "Tutor" && !isEssayPSTutor),
      onListItemClick: () => {
        onListItemClick({ path: tutorSubmissionsPath })
        setActiveNav(false)
      }
    },
    {
      title: "Seminars",
      path: seminarsPath,
      svg: <SeminarsSVG />,
      hidden: !(role === "Student" || isSeminarTutor || role === "Senior Tutor"),
      onListItemClick: () => {
        onListItemClick({ path: seminarsPath })
        setActiveNav(false)
      }
    },
    {
      title: "Dashboard",
      path: parentDashboardPath,
      svg: <ParentDashboardSVG />,
      hidden: role !== "Parent",
      onListItemClick: () => {
        onListItemClick({ path: parentDashboardPath })
        setActiveNav(false)
      }
    },
    {
      title: "Calendar",
      path: parentCalendarPath,
      svg: <CalendarSVG />,
      hidden: role !== "Parent",
      onListItemClick: () => {
        onListItemClick({ path: parentCalendarPath })
        setActiveNav(false)
      }
    },
    {
      title: "Curriculum",
      path: parentCurriculumPath,
      svg: <ParentCurriculumSVG />,
      hidden: role !== "Parent",
      onListItemClick: () => {
        onListItemClick({ path: parentCurriculumPath })
        setActiveNav(false)
      }
    },
    {
      title: "Tuition Reports",
      path: parentTutionReportPath,
      svg: <ParentTutionReportSVG />,
      hidden: role !== "Parent",
      onListItemClick: () => {
        onListItemClick({ path: parentTutionReportPath })
        setActiveNav(false)
      }
    },

    // {
    //   title: "Alerts",
    //   path: parentAlertsPath,
    //   svg: <ParentsAlertsSVG />,
    //   hidden: role !== "Parent",
    //   onListItemClick: () => {
    //     onListItemClick({ path: parentAlertsPath })
    //     setActiveNav(false)
    //   }
    // },
    {
      title: schoolName,
      path: schoolDashboardPath,
      svg: <SchoolDashboardSVG />,
      hidden: role !== "School Manager",
      onListItemClick: () => {
        onListItemClick({ path: schoolDashboardPath })
        setActiveNav(false)
      }
    },
    {
      title: "Tuition Reports",
      path: schoolTutionReportsPath,
      svg: <SchoolTutionReportSVG />,
      hidden: role !== "School Manager",
      onListItemClick: () => {
        onListItemClick({ path: schoolTutionReportsPath })
        setActiveNav(false)
      }
    },
    {
      title: "Alerts / Notifications",
      path: alertsPath,
      svg: <ParentsAlertsSVG />,
      hidden: role === "Student" || role === "Admin",
      onListItemClick: () => {
        onListItemClick({ path: alertsPath })
        setActiveNav(false)
      }
    },
    // {
    //   title: "Alerts",
    //   path: schoolAlertsPath,
    //   svg: <SchoolAlertsSVG />,
    //   hidden: role !== "School",
    //   onListItemClick: () => {
    //     onListItemClick({ path: schoolAlertsPath })
    //     setActiveNav(false)
    //   }
    // },
    {
      title: "Help",
      path: schoolHelpPath,
      svg: <SchoolHelpSVG />,
      hidden: role === "Admin" || role === "Student" || role === "Tutor" || role === "Senior Tutor",
      onListItemClick: () => {
        handleWhatsAppClick()
        // onListItemClick({ path: schoolHelpPath })
        setActiveNav(false)
      }
    },
    {
      title: "Help",
      path: "/tutor-help",
      svg: <TutorHelp />,
      hidden: role !== "Senior Tutor" && role !== "Tutor",
      onListItemClick: () => {
        onListItemClick({ path: "/tutor-help" })
        setActiveNav(false)
      }
    }
  ]
  const handleWhatsAppClick = () => {
    window.open("https://wa.me/+447868785503?text=Hi!", "_blank")
  }
  return (
    <>
      <aside id="sidebar"
        className={`${open ? "w-[215px] md:w-[260px]" : "w-[110px]"} ${
          navActive ? "active  z-[9999]" : ""
        } nav-aside__container relative flex flex-col items-center bg-[#071536] py-8 duration-300`}
      >
        {/* Control Button */}
        <div
          onClick={() => setOpen(!open)}
          className={`${
            !open
              ? "collapsed_btn -right-[15px] z-10 rotate-0"
              : "collapse-btn rotate-180"
          } collapse_btn absolute right-[-14px] top-[90px] flex h-[30px] w-[30px] cursor-pointer items-center justify-center rounded-full bg-white transition-all duration-500 ease-in-out z-[99]`}
        >
          <HiOutlineChevronRight
            size={open ? 20 : 20}
            className="text-dark-gray"
          />
        </div>
        {/* Logo */}
        <div
          className={`flex cursor-pointer items-center justify-center gap-x-4 ${
            open ? "max-w-20 max-h-20" : "max-h-[50px] max-w-[50px]"
          }`}
          onClick={() => onListItemClick({ path: "/", type: "RESET" })}
        >
          {/* <img
            width={open ? "80px" : "50px"}
            height={open ? "80px" : "50px"}
            src="/assets/logo.svg"
            alt="logo"
           
            className={`${open ? "w-20" : "w-[50px]"}
          cursor-pointer`}
          /> */}
          
          {(userHasSchoolImage && schoolImage) ? (
            <img
              width={open ? "80px" : "50px"}
              height={open ? "80px" : "50px"}
              src={schoolImage}
              alt="School Logo"
              className="hidden h-16 w-16 object-cover lg:block"
            />
          ):
          <Logo
            width={open ? "80px" : "50px"}
            height={open ? "80px" : "50px"}
          />
          }

        </div>
        {/* Sidebar Items */}
        <div
          className={`side-nav__scroll mb-auto mt-14 flex flex-col items-center ${
            open ? "" : ""
          }`}
        >
          <ul className={`${open ? "pr-6" : "pr-8"} flex flex-col gap-8`}>
            {listProps.map(
              item =>
                !item.hidden && (
                  <li
                    // onClick={item.onListItemClick}
                    key={item.path}
                    className={`${
                      open ? "ml-12" : "ml-10 flex justify-center"
                    } relative `}
                  >
                    <SidebarItem
                      open={open}
                      path={item.path}
                      title={item.title}
                      basePath={BASE_PATH}
                      childrenList={item.childrenList}
                      hasChildrenVisible={item.hasChildrenVisible}
                      setActiveNav={setActiveNav}
                      onClick={item.onListItemClick}
                      expandChildren={item.expandChildren}
                    >
                      {item.svg}
                    </SidebarItem>
                  </li>
                )
            )}
            {/* Logout and help */}
          </ul>
        </div>
        {/* <div className="mb-12"></div> */}
        <div
          className={`mb-4 mt-8 h-[1px] w-10/12 bg-neutral-9 md:w-7/12 ${
            open ? "ml-4" : "ml-2"
          }`}
        ></div>
        <div
          className={`flex w-full flex-col gap-7 self-start ${
            open ? "" : "items-center"
          } `}
        >
          {role === "Student" && (
            <div
              className={`${
                open
                  ? "items-center justify-evenly md:ml-2.5"
                  : "flex-col items-center justify-center gap-8"
              }
        -ml-1 flex  w-full `}
            >
              <span
                className={`${
                  location.pathname === "/help"
                    ? "text-white"
                    : "text-[#A5A5A5]"
                }
          cursor-pointer text-16p`}
                onClick={() => {
                  onListItemClick({ path: "/help" })
                  setActiveNav(false)
                }}
              >
                Help
              </span>
              {showUpgrades && (
                <span
                  className={`${
                    location.pathname === "/upgrades"
                      ? "text-white"
                      : "text-[#A5A5A5]"
                  }
            cursor-pointer text-16p`}
                  onClick={() => {
                    onListItemClick({ path: "/upgrades" })
                    setActiveNav(false)
                  }}
                >
                  Upgrades
                </span>
              )}
            </div>
          )}
          {!impersonating && <div
            className="flex cursor-pointer items-center gap-3"
            onClick={() => {
              localStorage.clear()
              navigate("/login")
            }}
          >
            <div
              className={`${
                open ? "ml-5 md:ml-12" : ""
              } flex h-10 w-10 cursor-pointer items-center justify-center rounded-full hover:bg-light-white`}
            >
              <Logout width={19} height={19} color="#A5A5A5" />
            </div>
            <span
              className={`text-base text-neutral-7 ${
                open ? "block" : "hidden"
              }`}
            >
              Logout
            </span>
          </div>}
          {impersonating && <div
            className="flex cursor-pointer items-center gap-3"
            onClick={() => {
              stopImpersonation();
            }}
          >
            <div
              className={`${
                open ? "ml-5 md:ml-12" : ""
              } flex h-10 w-10 cursor-pointer items-center justify-center rounded-full hover:bg-light-white`}
            >
              <Logout width={19} height={19} color="#A5A5A5" />
            </div>
            <span
              className={`text-base text-neutral-7 ${
                open ? "block" : "hidden"
              }`}
            >
              Exit Student View
            </span>
          </div>}
        </div>
      </aside>
      {navActive && (
        <div
          className="fixed right-0 z-[999] h-screen w-full bg-black opacity-20 lg:hidden"
          onClick={() => setActiveNav(false)}
        ></div>
      )}
    </>
  )
}

export default LayoutAside
